

//  RTL support js
if (document.getElementById('app-style').href.includes('rtl.min.css')) {
    document.getElementsByTagName('html')[0].dir = "rtl";
}
